export default "__VITE_ASSET__BNh$MtXa__"